import { Component, input } from '@angular/core';

@Component({
  selector: 'app-rating-icon',
  imports: [],
  templateUrl: './rating-icon.component.html',
  styleUrl: './rating-icon.component.css',
})
export class RatingIconComponent {
  public rating = input<{ path: string; alt: string }, number | undefined>(
    { path: 'rating/Neutral.png', alt: 'Neutral' },
    {
      transform: (v) => {
        if (v === undefined) {
          return { path: 'rating/Neutral.png', alt: 'Neutral' };
        } else if (v > 8.76) {
          return { path: 'rating/VeryLikely.png', alt: 'Very Likely' };
        } else if (v > 6.26) {
          return { path: 'rating/SomewhatLikely.png', alt: 'Somewhat Likely' };
        } else if (v > 3.76) {
          return { path: 'rating/Neutral.png', alt: 'Neutral' };
        } else if (v > 1.26) {
          return { path: 'rating/SomewhatUnlikely.png', alt: 'Somewhat Unlikely' };
        } else {
          return { path: 'rating/VeryUnlikely.png', alt: 'Very Unlikely' };
        }
      },
    },
  );
}
